import { Controller } from "@hotwired/stimulus"
import { initChartWithStats } from "../../vendor/chartjs"

// Job activity page line chart + stat box toggles.
export default class extends Controller {
  static targets = ["canvas"]

  connect() {
    this.chart = this.createChart()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  createChart() {
    const canvas = this.canvasTarget
    const statViews = document.querySelector('[data-stat-chartjs="views"]')
    const statPlanholders = document.querySelector('[data-stat-chartjs="planholders"]')
    if (!statViews || !statPlanholders) return null

    const chartViews = JSON.parse(canvas.dataset.views)
    const chartPlanholders = JSON.parse(canvas.dataset.planholders)
    const chartLabels = JSON.parse(canvas.dataset.labels)
    const labelInterval = parseInt(canvas.dataset.labelInterval || "1", 10)

    const chartDatasets = [
      {
        label: "Views",
        data: chartViews,
        borderColor: statViews.getAttribute("data-stat-chartjs-color"),
        backgroundColor: statViews.getAttribute("data-stat-chartjs-background-color"),
      },
      {
        label: "Planholders",
        data: chartPlanholders,
        borderColor: statPlanholders.getAttribute("data-stat-chartjs-color"),
        backgroundColor: statPlanholders.getAttribute("data-stat-chartjs-background-color"),
      },
    ]

    return initChartWithStats({
      canvas,
      datasets: chartDatasets,
      labels: chartLabels,
      defaultDataset: "views",
      options: {
        scales: {
          x: {
            ticks: {
              callback(value, index) {
                return index % labelInterval === 0 ? chartLabels[index] : ""
              },
            },
          },
        },
      },
    })
  }
}
